/* Skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195g1ejb%7Bmargin-inline%3Avar(--ds-space-300%2C24px)%7D");
import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { Actions } from './Actions';
import { Breadcrumbs } from './Breadcrumbs';
import { GriffinMainHeader } from './GriffinMainHeader';
import { Tabs } from './Tabs';
import { Title } from './Title';
const skeletonInlineStyles = {
  root: "_195g1ejb"
};
type Props = {
  hideBreadcrumbs?: boolean;
};
export const SkeletonActions = (): React.JSX.Element => <>
		<LoadingSkeleton width="85px" height="32px" />
		<LoadingSkeleton width="85px" height="32px" />
	</>;
export const SkeletonTabs = (): React.JSX.Element => <Inline space="space.150" xcss={skeletonInlineStyles.root}>
		<LoadingSkeleton width="65px" height="26px" marginTopPx={5} marginBottomPx={5} />
		<LoadingSkeleton width="65px" height="26px" marginTopPx={5} marginBottomPx={5} />
		<LoadingSkeleton width="65px" height="26px" marginTopPx={5} marginBottomPx={5} />
	</Inline>;
const SkeletonInternal = ({
  hideBreadcrumbs
}: Props) => {
  return <GriffinMainHeader>
			{!hideBreadcrumbs && <Breadcrumbs>
					<LoadingSkeleton width="70px" height="20px" marginTopPx={2} marginBottomPx={2} />
				</Breadcrumbs>}
			<Title>
				<LoadingSkeleton width="250px" height="32px" />
			</Title>
			<Actions>
				<SkeletonActions />
			</Actions>
			<Tabs>
				<SkeletonTabs />
			</Tabs>
		</GriffinMainHeader>;
};
export const Skeleton = (): React.JSX.Element => <SkeletonInternal />;
export const SkeletonWithoutBreadcrumbs = (): React.JSX.Element => <SkeletonInternal hideBreadcrumbs />;